import styled from '@emotion/styled'
import React from 'react'

import { ClockIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/ClockIcon'
import { DoorIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/DoorIcon'
import { MoneyIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/MoneyIcon'
import { PlanIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/PlanIcon'
import { WalletIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/WalletIcon'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { VendorServices } from '@f-fertighaus/applications/Next/types/vendorResponse'
import { DetailElement } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/DetailsSection/common/DetailElement/DetailElement'

interface GeneralVendorInfoProps {
  services: VendorServices
}

export const VENDOR_SERVICES = [
  {
    name: 'financing',
    icon: MoneyIcon,
    label: t('houseDetailPage.vendor.financing-advice')
  },
  {
    name: 'has_price_guarantee',
    icon: WalletIcon,
    label: t('houseDetailPage.vendor.price-guarantee')
  },
  {
    name: 'has_construction_time_guarantee',
    icon: ClockIcon,
    label: t('houseDetailPage.vendor.build-time-guarantee')
  },
  {
    name: 'has_individual_planning',
    icon: PlanIcon,
    label: t('houseDetailPage.vendor.individual-planning')
  },
  {
    name: 'has_blower_door_test',
    icon: DoorIcon,
    label: t('houseDetailPage.vendor.blower-door-test')
  }
] as const

export const RangeOfService = ({ services }: GeneralVendorInfoProps) => {
  const hasService = ({
    name: service
  }: {
    name: keyof VendorServices
  }): boolean => services?.[service] !== 'no'

  return (
    <Wrapper>
      {VENDOR_SERVICES.filter(hasService).map(({ name, icon, label }) => (
        <DetailElement key={name} icon={icon} name={label} verticalLayout />
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.ul`
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-inline-start: 0;
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: flex;
    flex-wrap: wrap;
    background: ${({ theme }) => theme.palette.glass[500]};
    padding-top: 16px;
    padding-right: 16px;

    & > li {
      margin-left: ${({ theme }) => theme.spacing(2)};
    }
  }
`
